import { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import AngelIcon from '@/components/base/AngelIcon';
import GratitudeResponse from './GratitudeResponse';

export default function GlobalLivingActions() {
  const { t } = useTranslation();
  const [gratitudeOpen, setGratitudeOpen] = useState(false);
  const [angelGlow, setAngelGlow] = useState(false);

  const openGratitude = useCallback(() => setGratitudeOpen(true), []);
  const closeGratitude = useCallback(() => setGratitudeOpen(false), []);

  const triggerAngelGlow = useCallback(() => {
    setAngelGlow(true);
    setTimeout(() => setAngelGlow(false), 800);
  }, []);

  return (
    <>
      {/* Fixed floating bar — bottom-right */}
      <div className="fixed bottom-5 right-5 z-50 flex items-center gap-1 bg-background-50/90 backdrop-blur-sm border border-background-200/70 rounded-full px-1.5 py-1.5 shadow-sm hover:shadow-md transition-shadow duration-300">
        {/* AI Angel */}
        <button
          onClick={triggerAngelGlow}
          className="flex items-center gap-1.5 pl-2 pr-2.5 py-1.5 rounded-full hover:bg-background-100 transition-colors cursor-pointer"
          aria-label="AI Angel"
        >
          <AngelIcon variant="gold" size="sm" />
          <span className="text-xs text-foreground-600 whitespace-nowrap hidden sm:inline">
            {t('globalLiving.aiAngel')}
          </span>
        </button>

        {/* Divider */}
        <div className="w-px h-4 bg-foreground-200/50" />

        {/* Gratitude Response */}
        <button
          onClick={openGratitude}
          className="flex items-center gap-1.5 pl-2.5 pr-2 py-1.5 rounded-full hover:bg-rose-50/50 transition-colors cursor-pointer group"
          aria-label="Gratitude Response"
        >
          <i className="ri-heart-line text-sm text-rose-300 group-hover:text-rose-400 transition-colors" />
          <span className="text-xs text-foreground-500 group-hover:text-foreground-700 whitespace-nowrap hidden sm:inline transition-colors">
            {t('globalLiving.gratitude')}
          </span>
        </button>
      </div>

      {/* Angel glow pulse — subtle feedback when clicked */}
      {angelGlow && (
        <div className="fixed bottom-5 right-5 z-40 pointer-events-none">
          <div className="w-10 h-10 rounded-full bg-amber-100/40 animate-ping" />
        </div>
      )}

      {/* Gratitude Response popup */}
      <GratitudeResponse isOpen={gratitudeOpen} onClose={closeGratitude} />
    </>
  );
}